import { render, staticRenderFns } from "./button.vue?vue&type=template&id=ca859fb4&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca859fb4')) {
      api.createRecord('ca859fb4', component.options)
    } else {
      api.reload('ca859fb4', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=ca859fb4&", function () {
      api.rerender('ca859fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/button/src/button.vue"
export default component.exports